import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  "feelConfident",
  "improveHealth",
  "increaseFitness",
  "specialEvent",
  "somethingElse",
] as const

export default function GoalReason() {
  return <SingleSelectPage translationKey="goalReason" options={OPTIONS} />
}
